import Select from "@/components/base/Select";
import {
  EMPLOYEE_ROLE_CONFIG,
  EMPLOYEE_ROLE_OPTIONS,
  EMPLOYEE_STATUS_CONFIG,
  EMPLOYEE_STATUS_OPTIONS,
} from "@/constants/employees";
import type { BranchDetail, EmployeeRole, EmployeeStatus } from "@/types";

interface EmployeeFiltersProps {
  query: string;
  onQueryChange: (value: string) => void;
  branch: string;
  onBranchChange: (value: string) => void;
  branchOptions: BranchDetail[];
  role: EmployeeRole | "all";
  onRoleChange: (value: EmployeeRole | "all") => void;
  status: EmployeeStatus | "all";
  onStatusChange: (value: EmployeeStatus | "all") => void;
}

export default function EmployeeFilters({
  query,
  onQueryChange,
  branch,
  onBranchChange,
  branchOptions,
  role,
  onRoleChange,
  status,
  onStatusChange,
}: EmployeeFiltersProps) {
  const branchSelectOptions = [
    { value: "all", label: "كل الفروع" },
    ...branchOptions.map((item) => ({ value: item.id, label: item.name })),
  ];

  const roleSelectOptions = [
    { value: "all", label: "كل الأدوار" },
    ...EMPLOYEE_ROLE_OPTIONS.map((item) => ({
      value: item,
      label: EMPLOYEE_ROLE_CONFIG[item].label,
      description: EMPLOYEE_ROLE_CONFIG[item].description,
    })),
  ];

  const statusSelectOptions = [
    { value: "all", label: "كل الحالات" },
    ...EMPLOYEE_STATUS_OPTIONS.map((item) => ({
      value: item,
      label: EMPLOYEE_STATUS_CONFIG[item].label,
    })),
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      <div className="flex items-center rounded-btn border border-background-200 bg-white px-3 focus-within:ring-2 focus-within:ring-primary-300">
        <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
          <i className="ri-search-line"></i>
        </span>
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="ابحث بالاسم أو رقم الجوال"
          className="w-full h-11 bg-transparent px-2 text-sm outline-none placeholder:text-foreground-300"
        />
      </div>

      <Select
        value={branch}
        options={branchSelectOptions}
        onChange={onBranchChange}
        icon="ri-store-2-line"
        ariaLabel="تصفية حسب الفرع"
      />

      <Select
        value={role}
        options={roleSelectOptions}
        onChange={(value) => onRoleChange(value as EmployeeRole | "all")}
        icon="ri-shield-user-line"
        ariaLabel="تصفية حسب الدور"
      />

      <Select
        value={status}
        options={statusSelectOptions}
        onChange={(value) => onStatusChange(value as EmployeeStatus | "all")}
        icon="ri-checkbox-circle-line"
        ariaLabel="تصفية حسب الحالة"
      />
    </div>
  );
}